import { render, staticRenderFns } from "./accidentAnalysis.vue?vue&type=template&id=6ff0d588&scoped=true"
import script from "./accidentAnalysis.vue?vue&type=script&lang=js"
export * from "./accidentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./accidentAnalysis.vue?vue&type=style&index=0&id=6ff0d588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0d588",
  null
  
)

export default component.exports